import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMenuSlice } from "../../compiler/global.interface";

export enum ESliceMenu {
    menu = "menu"
}

// this is current menu that user is active
const initialState: IMenuSlice = {
    code: "",
    create: false,
    update: false,
    delete: false,
    approve: false,
    read: false
};

const menuSlice = createSlice({
    name: ESliceMenu.menu,
    initialState,
    reducers: {
        setPermission: (state, action: PayloadAction<{ create: boolean; update: boolean; delete: boolean; approve: boolean; read: boolean }>) => {
            state.create = action.payload.create;
            state.update = action.payload.update;
            state.delete = action.payload.delete;
            state.approve = action.payload.approve;
            state.read = action.payload.read;
            return state;
        },
        setCurrentCode: (state, action: PayloadAction<string>) => {
            state.code = action.payload;
            return state;
        },
        setMenuStore: (state, action: PayloadAction<IMenuSlice>) => {
            state = action.payload;
            return state;
        },
        clearMenu: (state) => {
            state = initialState;
            return state;
        }
    }
});

export const { setCurrentCode, setPermission, setMenuStore, clearMenu } = menuSlice.actions;
export default menuSlice.reducer;
